import React from 'react';
import { Avatar, Tooltip } from 'antd';

export default function CatItem({ category, updateFilter }) {
  return (
    <li className="d-inline-block mr-1"
        onClick={(updateFilter) ? updateFilter(category.id) : null}>
      <Tooltip title={category.name}>
        <Avatar size="small" src={category.logo} className="cat-list-item mb-1" />
      </Tooltip>
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Categories/components/CategoriesList/CatItem.js